import React from "react";
import { IProps } from "./types";
import Icon from "../../../../../icon";
import { SocialIcon } from "../../../../components/SocialIcons";
import { EChoirSocialPageProvider } from "../../../../../../common/helpers/validationChoirSocialPage";
import { Container } from "./styles";

const SocialLinks = ({ website, socialPages = {} }: IProps) => {
    return (
        <Container>
            {website && (
                <a href={website} target="_blank">
                    <Icon i="publish" />
                </a>
            )}
            {socialPages.facebook && (
                <a href={socialPages.facebook} target="_blank">
                    <SocialIcon socialPage={EChoirSocialPageProvider.FACEBOOK} />
                </a>
            )}
            {socialPages.instagram && (
                <a href={socialPages.instagram} target="_blank">
                    <SocialIcon socialPage={EChoirSocialPageProvider.INSTAGRAM} />
                </a>
            )}
            {socialPages.twitter && (
                <a href={socialPages.twitter} target="_blank">
                    <SocialIcon socialPage={EChoirSocialPageProvider.TWITTER} />
                </a>
            )}
            {socialPages.youtube && (
                <a href={socialPages.youtube} target="_blank">
                    <SocialIcon socialPage={EChoirSocialPageProvider.YOUTUBE} />
                </a>
            )}
        </Container>
    );
};

export default SocialLinks;
